import { render } from "./Button.vue?vue&type=template&id=067f8786"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "067f8786"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('067f8786', __exports__)) {
    console.log('reload')
    api.reload('067f8786', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=067f8786", () => {
    console.log('re-render')
    api.rerender('067f8786', render)
  })

}


export default __exports__